import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GeoLocationTypeService } from './geo-location-type.service';
import { AppState } from '../../reducers/index';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector:        'app-geo-location-type',
  templateUrl:     'geo-location-type.component.html',
  styleUrls:       ['geo-location-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeoLocationTypeComponent implements OnInit, OnDestroy {

  model$;
  destroy$ = new Subject();

  /**
   * Toggle Dropdown
   */
  toggleDropdown (event?) {
    if (event) {
      event.stopPropagation();
    }
    this.geoLocationTypeService.toggleTypeDropdown();
  }

  /**
   * Show info for passed type from dropdown
   * @param type
   */
  showInfo (type) {
    this.geoLocationTypeService.showInfoForType(type);
  }

  /**
   * Select type from dropdown
   * @param type
   */
  selectType (type) {
    // TODO: Should update targeting spec on select
    this.geoLocationTypeService.selectType(type);
    this.geoLocationTypeService.toggleTypeDropdown(false);
  }

  constructor (private _store: Store<AppState>,
               private geoLocationTypeService: GeoLocationTypeService,
               private translateService: TranslateService) {}

  ngOnDestroy () {
    this.destroy$.next();
  }

  ngOnInit () {
    // TODO: Add Key navigation
    this.model$ = this._store.pipe(this.geoLocationTypeService.getModel);

    // Set types on init
    this.geoLocationTypeService.setTranslatedTypes();

    // Update types and selectedType when language change
    this.translateService.onLangChange
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.geoLocationTypeService.setTranslatedTypes();
        });
  }

}
